import { EventSchema } from '../../interfaces/EventInterfaces';
import { EVENT_NAME as EN } from '../../constants/EventName';
import { EVENT_PARAM_KEY as EPK } from '../../constants/EventParamKey';
import { CommonEventProperties } from '../../utils/CommonParams';

export const ProductViewedEventSchema: EventSchema = {
    eventName: EN.PRODUCT_VIEWED,
    params: {
        ...CommonEventProperties,
        BUSINESS_VERTICAL: EPK.BUSINESS_VERTICAL,
        PRODUCTS : EPK.PRODUCTS,
        INDEX: EPK.INDEX,
        EVENT_TYPE: EPK.EVENT_TYPE,
        QUERY_ID: EPK.QUERY_ID,
    }
}